import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="md:fixed bottom-0 z-[99] flex md:flex-row flex-col w-full items-center justify-center bg-primary">
      <div className="flex md:h-[42px] md:gap-0 gap-[6px] w-full items-center justify-center px-5 sm:justify-between md:justify-between lg:justify-between  md:flex-row flex-col">
        <div className="text-[14px] font-normal leading-[22px] tracking-[-0.14px] text-white">
          @ {t("copyright")}
        </div>
        {/* <div className=" items-center justify-center md:gap-[10px] gap-[6px] text-[14px] font-normal leading-[22px] tracking-[-0.14px] text-white flex lg:flex  md:flex-row flex-col">
          <div className="flex items-center gap-[16px]">
            <div>WSU</div>
            <div>028) 3920 9999 - Ext 789</div>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="2"
            height="16"
            viewBox="0 0 2 16"
            fill="none"
            className="hidden md:block"
          >
            <path d="M1 0V16" stroke="white" strokeOpacity="0.2" />
          </svg>
          <div className="flex items-center gap-[16px]">
            <div>Global pathway</div>
            <div>(028) 3535 8888 - Ext: 231</div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Footer;
